import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import Helmet from "react-helmet";
import { Button, ButtonGroup } from "reactstrap";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

import "./Header.scss";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }
  render() {
    return (
      <div>
        <Navbar
          light
          toggleable="xs"
          full
          className="navbar-expand-lg navbar-expand-md"
        >
          <NavbarBrand href="/">Datasert</NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav navbar>
              <NavItem>
                <Link className="nav-link" to="/products/realsync">
                  Realsync
                </Link>
              </NavItem>
              <NavItem>
                <Link className="nav-link" to="/products/realfire">
                  Realfire
                </Link>
              </NavItem>
              <NavItem>
                <Link className="nav-link" to="/products/scheduleright">
                  Scheduleright
                </Link>
              </NavItem>
              <NavItem>
                <span className="products-separator">|</span>
              </NavItem>
              <NavItem>
                <Link className="nav-link" to="/products/realfire/pricing">
                  Pricing
                </Link>
              </NavItem>
              <NavItem>
                <Link className="nav-link" to="/resources/docs">
                  Docs
                </Link>
              </NavItem>
              <NavItem>
                <Link className="nav-link" to="/resources/support">
                  Support
                </Link>
              </NavItem>
              <NavItem>
                <Link className="nav-link" to="/products/realfire/refer">
                  Refer Us
                </Link>
              </NavItem>
              <form className="form-inline my-2 my-lg-0">
                <ButtonGroup>
                  <Link
                    to="/products/realfire/buy"
                    className="btn btn-outline-success my-2 my-sm-0 btn-sm"
                  >
                    Buy Realfire
                  </Link>
                  <Link
                    to="/products/realfire"
                    className="btn btn-outline-success my-2 my-sm-0 btn-sm"
                  >
                    Download Realfire
                  </Link>
                </ButtonGroup>
              </form>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/Header.jsx